<template>
  <div>
    <div class="baseinfo">
      <div class="left">
        <div>
          <span class="name">{{data.spell_name}}</span>
          <span class="count">{{data.user_num}}人团</span>
        </div>
        <div class="time">活动时间：{{data.start_time|tsFormatLong}} ~ {{data.end_time|tsFormatLong}}</div>
      </div>
      <img
        v-if="data.spell_status==1"
        src="@/assets/images/group/status-1@3x.png"
        style="width:71px;"
      />
      <img
        v-else-if="data.spell_status==2"
        src="@/assets/images/group/status-2@3x.png"
        style="width:71px;"
      />
      <img
        v-else-if="data.spell_status==3"
        src="@/assets/images/group/status-3@3x.png"
        style="width:71px;"
      />
    </div>
    <div>
      <div class="section title">活动商品</div>
      <table class="table-shop" cellspacing="0">
        <thead>
          <tr>
            <th>商品名称</th>
            <th>商品类型</th>
            <th>单价（元）</th>
            <th>拼团价（元）</th>
            <th>团长价（元）</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{data.product_name}}</td>
            <td>{{data.product_type_name}}</td>
            <td>{{data.product_price/100}}</td>
            <td>{{data.spell_price/100}}</td>
            <td>{{data.head_price?data.head_price/100:"--"}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <div class="section title">数据</div>
      <div class="data-wrap">
        <div>
          <div>发起拼团数（团）</div>
          <div>{{data.total_group_number}}</div>
        </div>
        <div>
          <div>已成团数（团）</div>
          <div>{{data.success_group_number}}</div>
        </div>
        <div>
          <div>总收入（元）</div>
          <div>{{data.total_order_price/100}}</div>
        </div>
        <div>
          <div>退款总额（元）</div>
          <div>{{data.total_refund_price/100}}</div>
        </div>
        <div>
          <div>总优惠（元）</div>
          <div>{{data.total_discounted_price/100}}</div>
        </div>
      </div>
    </div>
    <Tabs class="tab-wrap" v-model="current" :animated="false">
      <TabPane label="订单记录" name="order">
        <Form :model="order.searchCondition" :label-width="80" inline>
          <FormItem label="订单状态" class="group-status">
            <EnumSelect
              type="GroupOrderStatus"
              selector="select"
              v-model="order.searchCondition.order_mix_status"
              style="width:100px;"
              clearable
            ></EnumSelect>
          </FormItem>
          <FormItem label="下单时间">
            <DatePicker
              ref="dateRange"
              type="datetimerange"
              placeholder="开始时间 - 结束时间"
              @on-change="onDateRange"
              style="width: 300px"
            ></DatePicker>
          </FormItem>
          <FormItem label="团编号">
            <Input
              v-model="order.searchCondition.group_number"
              placeholder="请输入团编号关键字"
              style="width:140px;"
              clearable
              @keydown.native.prevent.enter="onSearchOrder(false)"
            ></Input>
          </FormItem>
          <FormItem label="买家手机号">
            <Input
              v-model="order.searchCondition.mobile"
              placeholder="请输入买家手机号关键字"
              style="width:150px;"
              clearable
              @keydown.native.prevent.enter="onSearchOrder(false)"
            ></Input>
          </FormItem>
          <FormItem class="search-form-btns">
            <div class="btn-wrap form-item-search">
              <Button icon="ios-search" @click="onSearchOrder">搜索</Button>
              <Button icon="md-undo" @click="onResetOrder">重置</Button>
            </div>
          </FormItem>
        </Form>
        <Grid
          ref="gridOrder"
          :columns="order.columns"
          :data-url="'/api/spellGroup/showOrder/'+$route.query.id"
          :search="order.searchCondition"
          :rowsFormatter="onFormatterOrder"
          selectType="none"
          keyField="order_id"
          method="get"
          v-if="current=='order'"
        >
          <template slot="c1" slot-scope="{row}">
            <span>{{row.nickname}}</span>
            <span class="sp-head" v-if="row.open_group_uid == row.uid">团长</span>
          </template>
          <template slot="action" slot-scope="{row}">
            <Button type="text" :to="{name:'OrderGroupDetail', query:{ order_id:row.order_id}}">订单详情</Button>
          </template>
        </Grid>
      </TabPane>
      <TabPane label="成团明细" name="detail">
        <Form :model="detail.searchCondition" :label-width="80" inline>
          <FormItem label="成团状态" class="group-status">
            <EnumSelect
              type="GroupStatus"
              selector="select"
              v-model="detail.searchCondition.group_status"
              style="width:100px;"
              clearable
            ></EnumSelect>
          </FormItem>
          <FormItem label="团编号">
            <Input
              v-model="detail.searchCondition.group_number"
              placeholder="请输入团编号关键字"
              style="width:140px;"
              clearable
              @keydown.native.prevent.enter="onSearchDetail(false)"
            ></Input>
          </FormItem>
          <FormItem label="团长手机号">
            <Input
              v-model="detail.searchCondition.mobile"
              placeholder="请输入团长手机号关键字"
              style="width:150px;"
              clearable
              @keydown.native.prevent.enter="onSearchDetail(false)"
            ></Input>
          </FormItem>
          <FormItem class="search-form-btns">
            <div class="btn-wrap form-item-search">
              <Button icon="ios-search" @click="onSearchDetail">搜索</Button>
              <Button icon="md-undo" @click="onResetDetail">重置</Button>
            </div>
          </FormItem>
        </Form>
        <Grid
          ref="gridDetail"
          :columns="detail.columns"
          :data-url="'/api/spellGroup/showGroup/'+$route.query.id"
          :search="detail.searchCondition"
          :rowsFormatter="onFormatterDetail"
          selectType="none"
          keyField="group_id"
          method="get"
          v-if="current=='detail'"
        >
          <template slot="c1" slot-scope="{row}">
            <span>{{row.nickname+'/'+row.mobile}}</span>
          </template>
          <template slot="action" slot-scope="{row}">
            <Button type="text" @click="showGroupUser(row)">查看团员</Button>
          </template>
        </Grid>
      </TabPane>
    </Tabs>
    <Modal v-model="showGroupUserModal" title="拼团详情" width="800px">
      <div class="group-no">
        团编号：
        {{currentGroup.group_bn}}
      </div>
      <Form :model="user.searchCondition" :label-width="80" inline>
        <FormItem class="group-status" label="买家手机号">
          <Input
            v-model="user.searchCondition.mobile"
            placeholder="请输买家手机号关键字"
            style="width:140px;"
            clearable
            @keydown.native.prevent.enter="onSearchUser(false)"
          ></Input>
        </FormItem>
        <FormItem label="邀请人昵称">
          <Input
            v-model="user.searchCondition.nickname"
            placeholder="请输入邀请人昵称关键字"
            style="width:150px;"
            clearable
            @keydown.native.prevent.enter="onSearchUser(false)"
          ></Input>
        </FormItem>
        <FormItem class="search-form-btns">
          <div class="btn-wrap form-item-search">
            <Button icon="ios-search" @click="onSearchUser">搜索</Button>
            <Button icon="md-undo" @click="onResetUser">重置</Button>
          </div>
        </FormItem>
      </Form>
      <Grid
        ref="gridUser"
        :columns="user.columns"
        :data-url="url"
        :search="user.searchCondition"
        :rowsFormatter="onFormatterUser"
        selectType="none"
        keyField="uid"
        method="get"
        :autoLoadData="false"
      >
        <template slot="c1" slot-scope="{row}">
          <span>{{row.nickname+'（'+row.mobile+'）'}}</span>
          <span class="sp-head" v-if="row.is_open_user==1">团长</span>
        </template>
      </Grid>
      <template v-slot:footer>
        <Button type="primary" @click="showGroupUserModal=false">确定</Button>
      </template>
    </Modal>
  </div>
</template>
<script>
import {
  ShopType,
  GroupStatus,
  GroupOrderStatus,
  TerminalType,
  PayType,
  JoinFrom
} from "@/utils/enums.js";
export default {
  name: "GroupBookingDetail",
  data() {
    return {
      id: this.$route.query.id,
      data: {},
      current: "order",
      order: {
        searchCondition: {
          order_mix_status: "",
          start_time: "",
          end_time: "",
          group_number: "",
          mobile: ""
        },
        columns: [
          {
            title: "买家",
            key: "nickname",
            align: "left",
            slot: "c1",
            minWidth: 150
          },
          {
            title: "买家手机号",
            key: "mobile",
            align: "center",
            minWidth: 150
          },
          {
            title: "订单编号",
            key: "order_number",
            align: "center",
            minWidth: 150
          },
          {
            title: "团编号",
            key: "group_bn",
            align: "left",
            minWidth: 150
          },
          {
            title: "下单时间",
            key: "created_at_str",
            align: "center",
            minWidth: 150
          },
          {
            title: "订单状态",
            key: "order_mix_status_name",
            align: "center",
            minWidth: 150
          },
          {
            title: "操作",
            slot: "action",
            align: "center",
            minWidth: 100,
            fixed: "right"
          }
        ]
      },
      detail: {
        searchCondition: {
          group_status: "",
          group_number: "",
          mobile: ""
        },
        columns: [
          {
            title: "团编号",
            key: "group_bn",
            align: "left",
            minWidth: 150
          },
          {
            title: "团长",
            slot: "c1",
            align: "center",
            minWidth: 150
          },
          {
            title: "成团状态",
            key: "status_name",
            align: "center",
            minWidth: 150
          },
          {
            title: "操作",
            slot: "action",
            align: "center",
            minWidth: 100,
            fixed: "right"
          }
        ]
      },
      user: {
        searchCondition: { nickname: "", mobile: "" },
        columns: [
          {
            title: "团成员",
            slot: "c1",
            align: "left",
            minWidth: 250
          },
          {
            title: "参团来源",
            key: "join_from_name",
            align: "center",
            minWidth: 120
          },
          {
            title: "邀请人昵称",
            key: "inviter_nickname",
            align: "center",
            minWidth: 150
          },
          {
            title: "购买终端",
            key: "created_terminal_name",
            align: "center",
            minWidth: 100
          },
          {
            title: "支付方式",
            key: "pay_type_name",
            align: "center",
            minWidth: 120
          }
        ]
      },
      url: "",
      showGroupUserModal: false,
      currentGroup: {}
    };
  },
  async created() {
    let data = await this.$http.get("/api/spellGroup/showBase/" + this.id);
    data.product_type_name = ShopType.getValue(data.product_type);
    this.data = data;
  },
  methods: {
    onDateRange(range) {
      this.order.searchCondition.start_time = range[0];
      this.order.searchCondition.end_time = range[1];
    },
    onSearchOrder() {
      this.$refs.gridOrder.searchRefresh();
    },
    onResetOrder() {
      this.order.searchCondition.order_mix_status = "";
      this.order.searchCondition.start_time = "";
      this.order.searchCondition.end_time = "";
      this.order.searchCondition.group_number = "";
      this.order.searchCondition.mobile = "";
      this.$refs.dateRange.handleClear();
      this.onSearchOrder();
    },
    onFormatterOrder(rows) {
      rows.forEach(row => {
        row.created_at_str = this.$pub.timestampToTime(row.created_at);
        row.order_mix_status_name = GroupOrderStatus.getValue(
          row.order_mix_status
        );
      });
    },
    onSearchDetail() {
      this.$refs.gridDetail.searchRefresh();
    },
    onResetDetail() {
      this.detail.searchCondition.group_status = "";
      this.detail.searchCondition.group_number = "";
      this.detail.searchCondition.mobile = "";
      this.onSearchDetail();
    },
    onFormatterDetail(rows) {
      rows.forEach(row => {
        row.status_name = GroupStatus.getValue(row.status);
      });
    },
    showGroupUser(row) {
      this.showGroupUserModal = true;
      this.currentGroup = row;
      this.url = "/api/spellGroup/members/" + row.group_id;
      this.$nextTick(() => {
        this.$refs.gridUser.searchRefresh();
      });
    },
    onSearchUser() {
      this.$refs.gridUser.searchRefresh();
    },
    onResetUser() {
      this.user.searchCondition.mobile = "";
      this.user.searchCondition.nickname = "";
      this.onSearchUser();
    },
    onFormatterUser(rows) {
      rows.forEach(row => {
        row.created_terminal_name = TerminalType.getValue(row.created_terminal);
        row.pay_type_name = PayType.getValue(row.pay_type);
        if (row.join_from > 0) {
          row.join_from_name = JoinFrom.getValue(row.join_from);
        } else {
          row.join_from_name = "-";
        }
        row.inviter_nickname = row.inviter_nickname || "-";
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.baseinfo {
  display: flex;
  align-items: center;
  padding: 24px;
  border: 1px solid #ccc;
  .left {
    flex-grow: 1;
  }
  .name {
    font-size: 16px;
  }
  .count {
    margin-left: 10px;
    border: 1px solid #ccc;
    padding: 5px;
    border-radius: 5px;
  }
  .time {
    padding-top: 15px;
  }
}
.section {
  padding-top: 24px;
  font-size: 16px;
  margin-bottom: 18px;
  &::before {
    top: 28px;
    height: 18px;
  }
}
.table-shop {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ccc;
  th {
    background-color: #f8f8f9;
    text-align: left;
  }
  td,
  th {
    padding: 15px 0;
    padding-left: 10px;
    border: 1px solid #ccc;
  }
}
.data-wrap {
  display: flex;
  justify-content: space-between;
  > div {
    border: 1px solid #ccc;
    text-align: center;
    width: 200px;
    height: 96px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    > div:first-child {
      margin-bottom: 30px;
    }
  }
}
.tab-wrap {
  margin-top: 24px;
  overflow: visible;
}
.sp-head {
  background-color: #2d8cf0;
  color: white;
  padding: 5px;
  border-radius: 5px;
  margin-left: 5px;
}
.group-status {
  /deep/ {
    .ivu-form-item-label {
      width: auto !important;
    }
  }
}
.group-no {
  margin-bottom: 18px;
  font-weight: 500;
}
</style>